import "../styles/une.scss";
import "../styles/une_mobile.scss";
import banner from "./img/banner.webp";
import auto from "./img/auto.jpg";
import garantie from "./img/garantie.jpg";
import sanction from "./img/sanction.jpg";
import { useSelector,useDispatch } from "react-redux";
import {selectActivites,setActivite} from "../features/counterSlice";
import {useState,useEffect} from "react";
import {useHistory} from "react-router-dom";
import { RWebShare } from "react-web-share";
import Share from "./Share";

const Une=()=>{
    const history=useHistory();
    const dispatch=useDispatch();
    const activites=useSelector(selectActivites);

    const [data,set_data]=useState(null);

    useEffect(()=>{
        if(activites==null) return;
        set_data(activites);
    },[activites])
    return(
        <div className="une">
            <div className="top">
                <p className="text-3xl font-bold">A la une</p>
                <h2>Les dernières actualités et activités d'ADESCO</h2>
            </div>
            <div className="content">

                {
                    data?.slice(0,4).map((activite,i)=>{
                        return(
                            <div key={activite.id} className="relative ">
                                <img src={activite.acf.image} onClick={e=>{
                                dispatch(setActivite(activite));
                                history.push("/details-activite")
                            }}/>
                                <h2 onClick={e=>{
                                dispatch(setActivite(activite));
                                history.push("/details-activite")
                            }}>{activite.title.rendered}</h2>
                                <p>{activite.acf.resume}</p>
                                <Share 
                                item={activite}
                                title={activite.title.rendered}
                                url="https://ongadesco.org" 
                                text={activite.acf.resume} 
								image={activite?.acf?.image}
								type="activites"
								id={activite?.id}
								resume={activite.acf.resume}
								/>
                            </div>
                        );
                    })
                }
                
            </div>
        </div>
    );
}
export default Une;